/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { Dropdown, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import * as actiontype from './store/actiontypes';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  closeTab,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { SUCCESSMESSAGE_PRICE } from '../../../../SharedModules/Errors/constantMessageData';
import { arSummaryColumns } from '../tablehead';
import {
  setSelectManufacturerData,
  fetchAllManufacturerDetail,
  getContactDetails,
  maintainLabelerListData,
  setMaintainManufacturerTab,
} from '../../../Maintain/Manufacturer/store/ManufacturerAction';
import { getAllManufacturerDetail } from '../../../Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import ActionDropDownComp, { NameTooltipComp } from '../ActionDropdownComp';
import RedTextRenderComp from '../RedTextRenderComp';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

const ArSummaryByMfg = (props) => {
  const dispatch = useDispatch();
  const [load, setLoad] = React.useState(false);
  const [pinned, setPinned] = React.useState([]);
  const [fullScreen, setFullScreen] = React.useState(false);
  const activepgmCode = props?.location?.state?.rebateProgram
    ? props?.location?.state?.rebateProgram
    : props?.location?.value?.state?.rebateProgram;

  const find_ar_fld = useSelector((state) =>
    state?.sharedState?.ArSummaryMfgReducer?.ar_fld?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const ar_fld = find_ar_fld?.[activepgmCode];

  const find_ar_smry_tbl = useSelector((state) =>
    state?.sharedState?.ArSummaryMfgReducer?.ar_smry_tbl?.find((obj) => {
      return obj[activepgmCode];
    })
  );
  const ar_smry_tbl = find_ar_smry_tbl?.[activepgmCode];
  const frameworkComponents = {
    FullNameRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.data.mfgName}</b>;
      }
      return <NameTooltipComp data={cellInfo} />;
    },
    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    actionRenderer: (cellInfo) => {
      return (
        <ActionDropDownComp
          data={cellInfo}
          loadfn={setLoad}
          displayBy="mfg"
          selectPgm={false}
          extraData={ar_fld}
        />
      );
    },
  };

  const renderTooltip = (propsTooltip) => {
    return ar_fld?.qtrInfo.indexOf('DRAMS') !== -1 ||
      ar_fld?.qtrInfo.indexOf('First') !== -1 ? (
      <Tooltip id="add-tooltip" {...propsTooltip}>
        {ar_fld?.qtrInfo}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (filterApply) {
      const data = [
        {
          baseStateAmountDue: sum('baseStateAmountDue'),
          disputesAmt: sum('disputesAmt'),
          interestDue: sum('interestDue'),
          mfgId: '',
          mfgName: `Total:`,
          offsetDue: sum('offsetDue'),
          sumInvoiceBalance: sum('sumInvoiceBalance'),
          totalBalance: sum('totalBalance'),
          unAllocatedBalance: sum('unAllocatedBalance'),
          actions: 'hide',
          isBottomRow: true,
        },
      ];
      setPinned([...data]);
    } else {
      const data = [
        {
          baseStateAmountDue: ar_smry_tbl?.totalBaseStateAmountDue,
          disputesAmt: ar_smry_tbl?.finalTotaldisputedAmount,
          interestDue: ar_smry_tbl?.finalTotalInterestDue,
          mfgId: '',
          mfgName: `Total:`,
          offsetDue: ar_smry_tbl?.totalOffsetDue,
          sumInvoiceBalance: ar_smry_tbl?.totalSumInvoiceBalance,
          totalBalance: ar_smry_tbl?.finalTotalBalance,
          unAllocatedBalance: ar_smry_tbl?.totalUnAllocatedBalance,
          actions: 'hide',
          isBottomRow: true,
        },
      ];
      setPinned([...data]);
    }
  }, [filterApply, filteredRows]);

  let secondInfo = `Rebate Program: ${ar_fld?.pgmInfo}`;
  let fifthInfo = `Quarter Range:${
    !(ar_fld?.qtrInfo.includes('DRAMS') || ar_fld?.qtrInfo.includes('First'))
      ? ar_fld?.qtrInfo
      : ar_fld?.qtrInfo
  }`;

  return (
    <div className="tabs-container ARScreen" data-testid="ArSummaryByMfg">
      <Spinner load={load} />
      <CustomSeparator
        parent1="Research"
        parent2={`AR Summary By Mfg ${
          ar_fld?.pgmCd ? `[${ar_fld?.pgmCd}]` : ''
        }`}
      />
      <DisplaySuccessMessages successMessages={[]} />
      <ErrorMessages errorMessages={[]} />
      {!fullScreen && (
        <div className="">
          <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
            <div className="row">
              <div className="col-12 col-sm-6 col-xl-4">
                <div className="mui-custom-form">
                  <TextField
                    id="rebatepgm"
                    label="Rebate Program"
                    inputProps={{
                      id: 'rebatepgm',
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={ar_fld?.pgmInfo}
                    disabled
                  />
                </div>
              </div>
              <div className="col-12 col-sm-6 col-xl-4">
                <div className="mui-custom-form">
                  <OverlayTrigger placement="top" overlay={renderTooltip}>
                    <TextField
                      id="qtrrange"
                      label="Quarter Range"
                      inputProps={{
                        id: 'qtrrange',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={
                        ar_fld?.qtrInfo.indexOf('DRAMS') !== -1 ||
                        ar_fld?.qtrInfo.indexOf('First') !== -1
                          ? `${ar_fld?.qtrInfo?.substring(0, 20)}...`
                          : ar_fld?.qtrInfo
                      }
                      disabled
                    />
                  </OverlayTrigger>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      )}
      <div className="row">
        <div className="col-12 mt-3 panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          <TableGrid
            data-testid="manufacture-grid"
            gridHeight={fullScreen ? '70vh' : 400}
            rowData={ar_smry_tbl?.listOfTempMarSummary || []}
            columnDefs={arSummaryColumns}
            fileName="Accounts Receivable Summary By Manufacturer"
            frameworkComponents={frameworkComponents}
            // onSelectionChanged={onSelectionChanged}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            fullScreenView={fullScreen}
            handleFullScreenViewClick={() => setFullScreen(!fullScreen)}
            hideColumnsInPdf={['actions']}
            info={{
              secondInfo,
              fifthInfo,
            }}
            isScrollOn
            exportFile
            suppressCellFocus
            pinnedBottomRowData={
              ar_smry_tbl?.listOfTempMarSummary &&
              ar_smry_tbl?.listOfTempMarSummary.length
                ? pinned
                : undefined
            }
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            // helpMessage={Constants.DOUBLE_CLICK_INFO}
            // cellClickedListener={cellClickedListener}
          />
        </div>
      </div>
    </div>
  );
};

export default ArSummaryByMfg;
